<template>
  <div class="border-top">
    <v-list-item class="text-left mx-2" flat v-if="isDeliveryTypeSelected">
      <v-list-item-content>
        <v-list-item-title class="subtitle-2">
          {{getDeliveryTypeName(deliveryType.delivery_type)}}
          <span class="green--text text--darken-2 font-weight-bold" v-if="deliveryIsFree(deliveryType, totalCost)">&nbsp;Gratis</span>
          <span class="font-weight-bold" v-else>&nbsp;{{ currency(deliveryType.cost) }}</span>
        </v-list-item-title>
        <v-list-item-subtitle class="subtitle-2">
          <span class="grey--text text--darken-1" v-if="deliveryType.delivery_type === 'collect-in-store'">
            Retira a partir del {{ dateFormat(addDaysToCurrentDate(deliveryType.delivery_days), 'D MMM YYYY') }}
          </span>
          <span class="grey--text text--darken-1" v-else>
            Llega el {{ dateFormat(addDaysToCurrentDate(deliveryType.delivery_days), 'D MMM YYYY') }} a tu dirección
          </span>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action class="text-right">
        <a class="subtitle-2 blue--text link" @click="changeDeliveryType" v-if="$vuetify.breakpoint.mdAndUp">
          Cambiar
        </a>
        <v-btn class="mr-n10" icon @click="changeDeliveryType" v-else>
          <v-icon color="blue">chevron_right</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>

    <div v-else-if="showDeliveryTypes">
      <div class="list-title px-6 py-2 font-weight-bold">
        Por favor selecciona el método de envío
      </div>
      <v-list flat dense class="py-0">
        <v-list-item-group>
          <v-list-item class="text-left border-top" flat v-for="(delivery, index) in getCheckoutDeliveryTypes(totalCost)" :key="'delivery_types_list_'+index" @click="selectDeliveryType(delivery)">
            <v-list-item-action class="ml-1 mr-2">
              <v-checkbox
                :input-value="deliveryType && isEqualObject(deliveryType, delivery)"
                color="primary"
                dense>
              </v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="subtitle-2">
                <span class="font-weight-bold grey--text text--darken-3">{{getDeliveryTypeName(delivery.delivery_type)}}</span>
              </v-list-item-title>
              <v-list-item-subtitle class="subtitle-2">
                <span class="grey--text text--darken-1" v-if="delivery.delivery_type === 'collect-in-store'">
                  Retira a partir del {{ dateFormat(addDaysToCurrentDate(delivery.delivery_days), 'D MMM YYYY') }}
                </span>
                <span class="grey--text text--darken-1" v-else>
                  Llega el {{ dateFormat(addDaysToCurrentDate(delivery.delivery_days), 'D MMM YYYY') }} a tu dirección
                </span>
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action class="mr-2">
              <div class="green--text text--darken-2" v-if="deliveryIsFree(delivery, totalCost)">Gratis</div>
              <div v-else>{{ currency(delivery.cost) }}</div>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { isEqualObject } from '@/shared/compare'
import { dateFormat, currency } from '@/shared/format'
import { addDaysToCurrentDate } from '@/shared/date'
import { getDeliveryTypeName, deliveryIsFree } from '@/shared/delivery'

export default {
  data () {
    return {
      isEqualObject,
      dateFormat,
      currency,
      addDaysToCurrentDate,
      getDeliveryTypeName,
      deliveryIsFree,
      view: 'list'
    }
  },
  computed: {
    ...mapState('cart', ['deliveryType']),
    ...mapState('shipping', ['deliveryTypes']),
    ...mapGetters('cart', ['totalCost']),
    ...mapGetters('shipping', ['getCheckoutDeliveryTypes']),
    isDeliveryTypeSelected () {
      return !!this.deliveryType && this.view === 'selected'
    },
    showDeliveryTypes () {
      return !!this.deliveryTypes && this.view === 'list'
    }
  },
  methods: {
    ...mapMutations('cart', ['setDeliveryType', 'updateDeliveryTypeByCost']),
    selectDeliveryType (deliveryType) {
      this.setDeliveryType(deliveryType)
      this.view = 'selected'
    },
    changeDeliveryType () {
      this.view = 'list'
    }
  },
  mounted () {
    if (this.deliveryType) {
      this.view = 'selected'
    }
  },
  watch: {
    totalCost: function (value) {
      this.updateDeliveryTypeByCost({ deliveryTypes: this.deliveryTypes, totalCost: value })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~vuetify/src/styles/settings/_variables';
  .border-top{
    border-top: 1px solid;
    border-color: rgba(0, 0, 0, 0.12);
  }
  .list-title {
    color: #000000DE;
  }
</style>
